;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { TopBarAccountButtonGreeting } from './TopBarAccountButtonGreeting'
import { TopBarAccountButtonIcon } from './TopBarAccountButtonIcon'
import { TopBarAccountButtonRoot } from './TopBarAccountButtonRoot'

export const TopBarAccountButton = Object.assign(TopBarAccountButtonRoot, {
  Greeting: TopBarAccountButtonGreeting,
  Icon: TopBarAccountButtonIcon,
})
